import React from 'react'
import { connect } from 'react-redux'

import renderRoutes from '../../../../../routes/renderRoutes'
import WindowDefault from '../../../../../components/Windows/WindowDefault'


const RubberProductsContainer = (props) => {
  let { route, business, location, windowModal, closeWindowModal } = props

  return (
    <WindowDefault windowModal={windowModal}>
      { renderRoutes({
        routes: route.routes,
        extraProps: { business, windowModal, closeWindowModal },
        location
      }) }
    </WindowDefault>
  )
}

export default connect()(RubberProductsContainer)
